function formatDate(value) {
    const source = String(value || '').trim();
    if (!source) return '';
    const match = source.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) return `${match[3]}.${match[2]}.${match[1]}`;
    const date = new Date(source);
    return Number.isNaN(date.getTime())
        ? source
        : date.toLocaleDateString('ru-RU');
}

export function employeeAbsencePeriodLabel(absence) {
    const value = absence || {};
    const startsOn = formatDate(value.starts_on);
    const confirmedEndsOn = formatDate(value.confirmed_ends_on);
    const plannedEndsOn = formatDate(value.planned_ends_on);
    if (startsOn && confirmedEndsOn) {
        return `с ${startsOn} по ${confirmedEndsOn}`;
    }
    if (startsOn && plannedEndsOn) {
        return `с ${startsOn} по ${plannedEndsOn} (планово)`;
    }
    if (startsOn) return `с ${startsOn}, без даты окончания`;
    if (confirmedEndsOn) return `по ${confirmedEndsOn}`;
    if (plannedEndsOn) return `по ${plannedEndsOn} (планово)`;
    return '';
}

export function employeeAbsenceTooltip(absence, fallbackLabel) {
    const value = absence || {};
    const label = fallbackLabel
        || (value.code && value.label ? `${value.code} — ${value.label}` : '')
        || value.label
        || 'Временно отсутствует';
    const period = employeeAbsencePeriodLabel(value);
    return period ? `${label}. Период: ${period}` : label;
}
